export default "__VITE_ASSET__CddYBquh__"